//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtModal',
  props: {
    closeOnOutsideClick: {
      type: Boolean,
      default: true,
    },
    closeButtonPositionInHeader: {
      type: String,
      default: '',
    },
    autoCloseInTime: {
      type: Number,
      default: 0,
    },
    headerColor: {
      type: String,
      default: 'transparent',
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'large',
      validator: function (value) {
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
    },
  },
  data: function data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    hasHeaderSlot: function hasHeaderSlot() {
      return !!this.$slots['modal-header'];
    },
    hasFooterSlot: function hasFooterSlot() {
      return !!this.$slots['modal-footer'];
    },
    closeButtonClass: function closeButtonClass() {
      return ("pt-modal-close-button-" + (this.closeButtonPositionInHeader));
    },
  },
  watch: {
    modalVisible: function modalVisible(newvalue) {
      document.body.style.overflow = newvalue ? 'hidden' : '';

      if (newvalue) {
        document.addEventListener('keydown', this.handleKeyDown);
      } else {
        document.removeEventListener('keydown', this.handleKeyDown);
      }
    },
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    onOutsideClick: function onOutsideClick(e) {
      if (!this.closeOnOutsideClick) {
        return;
      }

      var MODAL_CONTAINER_CLASS = 'modal-container';
      var MODAL_MASK_CLASS = 'modal-mask';
      var currentTarget = e.target;
      var targetClass = currentTarget.className;
      var shouldClose = false;

      while (true) {
        if (targetClass.indexOf(MODAL_CONTAINER_CLASS) > -1) {
          break;
        }

        if (targetClass.indexOf(MODAL_MASK_CLASS) > -1) {
          shouldClose = true;
          break;
        }

        currentTarget = currentTarget.parentElement;
        targetClass = currentTarget.className;
      }

      if (shouldClose) {
        this.closeModal();
      }
    },
    showModal: function showModal() {
      this.modalVisible = true;
      this.$emit('onOpen');

      if (this.autoCloseInTime > 0) {
        setTimeout(this.closeModal, this.autoCloseInTime);
      }
    },
    closeModal: function closeModal() {
      this.$emit('beforeModalClose');
      this.modalVisible = false;
      this.$emit('onClose');
    },
    onCloseButtonClicked: function onCloseButtonClicked() {
      this.closeModal();
    },
    handleKeyDown: function handleKeyDown(event) {
      if (event.key === 'Escape' || event.keyCode === 27 || event.which === 27) {
        this.closeModal();
      }
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.modalVisible
    ? _c("transition", { attrs: { name: "pt-modal" } }, [
        _c(
          "div",
          { staticClass: "pt-modal-mask", on: { click: _vm.onOutsideClick } },
          [
            _c("div", { staticClass: "pt-modal-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "pt-modal-container",
                  class: [
                    { "bg-transparent": _vm.transparent },
                    "pt-modal-" + _vm.size
                  ]
                },
                [
                  _vm.closeButtonPositionInHeader || _vm.hasHeaderSlot
                    ? _c(
                        "div",
                        {
                          staticClass: "pt-modal-header",
                          class: [
                            { "border-none": _vm.noBorder },
                            _vm.closeButtonClass
                          ],
                          style: { "background-color": _vm.headerColor }
                        },
                        [
                          _vm.closeButtonPositionInHeader &&
                          _vm.closeButtonPositionInHeader === "left"
                            ? _c(
                                "div",
                                {
                                  staticClass: "pt-header-close-icon",
                                  on: { click: _vm.onCloseButtonClicked }
                                },
                                [_c("i", { staticClass: "fa fa-times" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasHeaderSlot
                            ? _c(
                                "div",
                                { staticClass: "pt-header-body" },
                                [
                                  _vm._t("modal-header", [
                                    _vm._v("Default header")
                                  ])
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.closeButtonPositionInHeader &&
                          _vm.closeButtonPositionInHeader === "right"
                            ? _c(
                                "div",
                                {
                                  staticClass: "pt-header-close-icon",
                                  on: { click: _vm.onCloseButtonClicked }
                                },
                                [_c("i", { staticClass: "fa fa-times" })]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pt-modal-body" },
                    [_vm._t("modal-body", [_vm._v("Default body")])],
                    2
                  ),
                  _vm._v(" "),
                  _vm.hasFooterSlot
                    ? _c(
                        "div",
                        {
                          staticClass: "pt-modal-footer",
                          class: { "border-none": _vm.noBorder }
                        },
                        [_vm._t("modal-footer", [_vm._v("Default footer")])],
                        2
                      )
                    : _vm._e()
                ]
              )
            ])
          ]
        )
      ])
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PtModal = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'PtPhotoGallery',
  components: { PtModal: PtModal },
  props: {
    title: {
      type: String,
      default: 'Photo Gallery',
    },
    images: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data: function data() {
    return {
      selectedIndex: this.index,
      total: 0,
    };
  },
  computed: {
    selectedImage: function selectedImage() {
      return this.images[this.selectedIndex];
    },
  },
  created: function created() {
    this.total = this.images.length;
  },
  methods: {
    show: function show() {
      this.$refs.photoModal.showModal();
    },
    previous: function previous() {
      if (this.selectedIndex > 0) {
        this.selectedIndex -= 1;
      }
    },
    next: function next() {
      if (this.selectedIndex < this.total) {
        this.selectedIndex += 1;
      }
    },
    setIndex: function setIndex(index) {
      this.selectedIndex = index;
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "photo-gallery-container" },
    [
      _c(
        "pt-modal",
        {
          ref: "photoModal",
          attrs: { "close-button-position-in-header": "right" }
        },
        [
          _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              attrs: { slot: "modal-body" },
              on: {
                keydown: [
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "left", 37, $event.key, [
                        "Left",
                        "ArrowLeft"
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 0) {
                      return null
                    }
                    return _vm.previous($event)
                  },
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "right", 39, $event.key, [
                        "Right",
                        "ArrowRight"
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 2) {
                      return null
                    }
                    return _vm.next($event)
                  }
                ]
              },
              slot: "modal-body"
            },
            [
              _vm.selectedImage
                ? _c("div", { staticClass: "photo-gallery-image-container" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.selectedImage.image,
                        alt: _vm.selectedImage.title
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "photo-gallery-image-title" }, [
                      _vm._v(_vm._s(_vm.selectedImage.title))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedIndex > 0,
                      expression: "selectedIndex > 0"
                    }
                  ],
                  staticClass:
                    "photo-gallery-navigator photo-gallery-navigator__previous",
                  attrs: { type: "button", autofocus: "" },
                  on: { click: _vm.previous }
                },
                [_c("i", { staticClass: "fa fa-arrow-left" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedIndex < _vm.total - 1,
                      expression: "selectedIndex < total - 1"
                    }
                  ],
                  staticClass:
                    "photo-gallery-navigator photo-gallery-navigator__next",
                  attrs: { type: "button", autofocus: "" },
                  on: { click: _vm.next }
                },
                [_c("i", { staticClass: "fa fa-arrow-right" })]
              )
            ]
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PhotoGallery = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

export { PhotoGallery as PtPhotoGallery };
